/**
 * @fileoverview Input/output schemas for key-events-neutralizer-v1.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.chapterContext.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  neutralizedKeyEvents: z
    .string()
    .describe('The rewritten Key Events in neutral, functional tone. Preserves all beats and structure.'),
  neutralizedChapterGoals: z
    .object({
      plotDevelopment: z.string().describe('Neutralized plot development. Empty string if input was empty.'),
      charDevelopment: z.string().describe('Neutralized character development. Empty string if input was empty.'),
      stakesAndTension: z.string().describe('Neutralized stakes / tension. Empty string if input was empty.'),
    })
    .describe('The rewritten Chapter Goals in neutral, functional tone.'),
});

export type Output = z.infer<typeof OutputSchema>;
